import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

// Import namespace JSON files
import commonTranslations from './locales/de/common.json'
import loginTranslations from './locales/de/login.json'
import usersTranslations from './locales/de/users.json'
import membersTranslations from './locales/de/members.json'
import ordersTranslations from './locales/de/orders.json'
import servicesTranslations from './locales/de/services.json'
import adminTranslations from './locales/de/admin.json'
import errorsTranslations from './locales/de/errors.json'
import menuTranslations from './locales/de/menu.json'
import pricingTranslations from './locales/de/pricing.json'
import ledgerTranslations from './locales/de/ledger.json'
import billingTranslations from './locales/de/billing.json'
import reportsTranslations from './locales/de/reports.json'
import socialAccountTranslations from './locales/de/socialAccount.json'

// Define available namespaces
export const namespaces = [
    'common',
    'login',
    'users',
    'members',
    'orders',
    'services',
    'admin',
    'errors',
    'menu',
    'pricing',
    'ledger',
    'billing',
    'reports',
    'socialAccount'
] as const

export type Namespace = typeof namespaces[number]

// Configure i18next with namespace-based resources
i18n
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: 'de',
        defaultNS: 'common',
        ns: namespaces,
        interpolation: {
            escapeValue: false // React escapes by default
        },
        resources: {
            de: {
                common: commonTranslations,
                login: loginTranslations,
                users: usersTranslations,
                members: membersTranslations,
                orders: ordersTranslations,
                services: servicesTranslations,
                admin: adminTranslations,
                errors: errorsTranslations,
                menu: menuTranslations,
                pricing: pricingTranslations,
                ledger: ledgerTranslations,
                billing: billingTranslations,
                reports: reportsTranslations,
                socialAccount: socialAccountTranslations
            }
        }
    })

export default i18n
